module.exports = __webpack_public_path__ + "static/img/cooperative.8f1b983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/cooperative.png
// module id = WmgH
// module chunks = 2